import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function SceneSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="w-full py-14 md:py-24 px-6 relative" style={{
    background: '#0D1B2A'
  }} data-id="element-275">
      <div className="max-w-3xl mx-auto" data-id="element-276">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`} data-id="element-277">
          <div className="amber-divider mb-8 md:mb-12" data-id="element-278" />

          <div className="space-y-4 md:space-y-8 text-base md:text-xl leading-relaxed" style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#F5F0E8'
        }} data-id="element-279">
            <p data-id="element-280">Il est 21h30.</p>
            <p data-id="element-281">Les enfants sont couchés.</p>
            <p data-id="element-282">Tu t'assois enfin.</p>
            <p data-id="element-283">Mais ton cerveau, lui, court encore.</p>

            {/* Thought Bubbles */}
            <div className="my-8 md:my-12 space-y-3 md:space-y-4 pl-6 border-l-2 border-amber-500/30" data-id="element-284">
              <p className="italic" style={{
              color: '#D4A853',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-285">
                → "J'ai signé la feuille ?"
              </p>
              <p className="italic" style={{
              color: '#D4A853',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-286">
                → "Y'a plus de lait."
              </p>
              <p className="italic" style={{
              color: '#D4A853',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-287">
                → "Le mail de mon boss..."
              </p>
              <p className="italic" style={{
              color: '#D4A853',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-288">
                → "L'anniversaire de samedi..."
              </p>
            </div>

            <p data-id="element-289">Tu es épuisée.</p>
            <p data-id="element-290">Mais ton cerveau refuse d'appuyer sur OFF.</p>
            <p data-id="element-291">Ce n'est pas un manque de volonté.</p>
            <p data-id="element-292">
              <strong style={{
              color: '#D4A853'
            }} data-id="element-293">
                C'est de la biologie.
              </strong>
            </p>
            <p data-id="element-294">
              Ton cerveau retient TOUTES les tâches non terminées. En boucle.
              Sans arrêt.
            </p>

            {/* Stat Callout */}
            <div className="my-8 md:my-12 p-6 md:p-8 rounded-2xl text-center" style={{
            background: 'rgba(212,168,83,0.05)',
            border: '1px solid rgba(212,168,83,0.2)'
          }} data-id="element-295">
              <p className="text-2xl md:text-4xl font-bold mb-3 md:mb-4" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#D4A853'
            }} data-id="element-296">
                327 micro-tâches par jour.
              </p>
              <p className="text-sm md:text-base" style={{
              color: '#C8C0B0'
            }} data-id="element-297">
                C'est ce que porte une femme active.
                <br data-id="element-298" />
                <span className="text-sm opacity-70 mt-1 block" data-id="element-299">
                  — Université de Californie, 2023
                </span>
              </p>
            </div>

            <p className="text-center text-xl md:text-2xl font-bold mt-8 md:mt-12" style={{
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-300">
              Ton cerveau n'est pas fait pour ça.
            </p>
          </div>
        </div>
      </div>
    </section>;
}